import React from "react";
import { defineMessages } from "react-intl";
import { makeStyles } from "tss-react/mui";
import { Button } from "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import { Icon } from "../../../components/icons/Icon.js";
import { CustomIcon } from "../../../components/icons/types.js";
import "../../../components/icons/ExpandMoreIcon.js";
import { useReferralLinkButton } from "../hooks.js";
const localized = defineMessages({
  buttonLabel: {
    id: "ReferralLink_buttonLabel",
    defaultMessage: "Copy"
  },
  buttonCopiedLabel: {
    id: "ReferralLink_copySuccess",
    defaultMessage: "Copied"
  }
});
const useStyles = makeStyles()((theme) => ({
  referralLinkButton: {
    marginLeft: theme.spacing(2),
    height: theme.custom.denseButtonHeight + 2,
    padding: theme.spacing(1.25, 2),
    minWidth: "auto",
    borderRadius: theme.custom.defaultBorderRadius * 2
  },
  referralLinkButtonIcon: {
    fontSize: "1em !important",
    color: theme.palette.secondary.main
  }
}));
function ReferralLinkButton({ uid, disabled, personalReferralCode }) {
  const { classes } = useStyles();
  const { handleClick, isClicked, isProgress } = useReferralLinkButton(uid);
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      label: isClicked ? localized.buttonCopiedLabel : localized.buttonLabel,
      onClick: handleClick,
      className: classes.referralLinkButton,
      startIcon: /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.Copy, className: classes.referralLinkButtonIcon }),
      disabled: disabled || !personalReferralCode || isProgress || isClicked
    }
  );
}
export {
  ReferralLinkButton
};
//# sourceMappingURL=ReferralLinkButton.js.map
